export enum UserClaims {
    EXTENSION_PORTALCRM_PERSONID = "extension_portalcrm_personid",
    EXTENSION_PORTALCRM_PCSFEESDUE = "extension_portalcrm_pcsFeesDue"
}